enum AccessReportsPageOptionsElementEnum {
  CoverPage = "coverPage",
  ContentsPage = "contentsPage",
  SplitPagesBySpecialty = "splitPagesBySpecialty",
  SplitEmployeeGroupByStandard = "splitEmployeeGroupByStandard",
  SeparatorPage = "separatorPage",
  LegalDisclaimer = "legalDisclaimer",
}

export { AccessReportsPageOptionsElementEnum };
